// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"187":"194dade6334389356fb9","515":"94b6d500d77ae9a8befe","572":"dcc0080d6855a5d92d3e"}[chunkId] + ".js";
};